import axios from "axios";

import { headers, host } from "./shared";

export const createClass = async (schoolClass, schoolId, accessToken) => {
  try {
    return await axios.post(
      `${host}/api/schools/${schoolId}/classes`,
      { school_class: schoolClass },
      headers(accessToken),
    );
  } catch (error) {
    const errorMessage = error?.response?.data?.error;
    throw errorMessage ? new Error(errorMessage) : error;
  }
};

export const putClass = async (schoolClass, schoolId, classId, accessToken) => {
  try {
    return await axios.put(
      `${host}/api/schools/${schoolId}/classes/${classId}`,
      { school_class: schoolClass },
      headers(accessToken),
    );
  } catch (error) {
    const errorMessage = error?.response?.data?.error;
    throw errorMessage ? new Error(errorMessage) : error;
  }
};

export const getClasses = async (schoolId, accessToken, filterParams = {}) => {
  const hasFilterParams = Object.keys(filterParams).length > 0;
  let filterParamsString = hasFilterParams ? "?" : "";
  if (hasFilterParams) {
    Object.keys(filterParams).forEach((key) => {
      const isLastKey = key === Object.keys(filterParams)[-1];
      filterParamsString += `${key}=${filterParams[key]}${!isLastKey && "&"}`;
    });
    filterParamsString = filterParamsString.slice(0, -1);
  }
  return await axios.get(
    `${host}/api/schools/${schoolId}/classes${filterParamsString}`,
    headers(accessToken),
  );
};

export const getClass = async (classId, schoolId, accessToken) => {
  return await axios.get(
    `${host}/api/schools/${schoolId}/classes/${classId}`,
    headers(accessToken),
  );
};

export const addClassMember = async (
  userId,
  classId,
  schoolId,
  accessToken,
  type,
) => {
  return await axios.post(
    `${host}/api/schools/${schoolId}/classes/${classId}/members`,
    { class_member: { user_id: userId, type } },
    headers(accessToken),
  );
};

export const deleteStudentFromClass = async (
  studentId,
  classId,
  schoolId,
  accessToken,
) => {
  let response;
  try {
    response = await axios.delete(
      `${host}/api/schools/${schoolId}/classes/${classId}/members/${studentId}`,
      headers(accessToken),
    );
    return response.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.error;
    throw errorMessage ? new Error(errorMessage) : error;
  }
};

export const getClassMembers = async (classId, schoolId, accessToken) => {
  return await axios.get(
    `${host}/api/schools/${schoolId}/classes/${classId}/members`,
    headers(accessToken),
  );
};

export const createLesson = async (lesson, accessToken) => {
  try {
    return await axios.post(
      `${host}/api/lessons`,
      { lesson },
      headers(accessToken),
    );
  } catch (error) {
    const errorMessage = error?.response?.data?.error;
    throw errorMessage ? new Error(errorMessage) : error;
  }
};

export const getLessons = async (classId, accessToken) => {
  return await axios.get(
    `${host}/api/lessons?school_class_id=${classId}`,
    headers(accessToken),
  );
};

export const getLesson = async (lessonId, accessToken) => {
  const response = await axios.get(
    `${host}/api/lessons/${lessonId}`,
    headers(accessToken),
  );
  return response;
};

export const updateLesson = async (lesson, accessToken) => {
  return await axios.put(
    `${host}/api/lessons/${lesson.id}`,
    { lesson },
    headers(accessToken),
  );
};

export const copyLesson = async (lessonId, classId, accessToken) => {
  return await axios.post(
    `${host}/api/lessons/${lessonId}/copy`,
    { school_class_id: classId },
    headers(accessToken),
  );
};

export const getInvitation = async (tokenId, accessToken) => {
  return await axios.get(
    `${host}/api/teacher_invitations/${tokenId}`,
    headers(accessToken),
  );
};

export const acceptInvitation = async (tokenId, accessToken) => {
  return await axios.put(
    `${host}/api/teacher_invitations/${tokenId}/accept`,
    {},
    headers(accessToken),
  );
};
